import { Link } from 'react-router-dom';
import { ExternalLink, Instagram, Mail, Phone } from 'lucide-react';
import { FOOTER_SITE, SITE } from '../content/siteCopy';
import { LINKS_EXTERNOS } from '../data/catalogoDestaque';

export default function SiteFooter() {
  return (
    <footer className="mt-auto bg-lunins-ink text-lunins-cream">
      <div className="mx-auto max-w-6xl px-4 py-14 md:py-20">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-display text-lg font-semibold tracking-tight text-lunins-cream">
              Lunins<span className="text-lunins-gold">.</span>
            </p>
            <p className="mt-2 font-serif text-sm italic text-lunins-gold/90">{SITE.tagline}</p>
            <p className="mt-2 text-sm text-lunins-cream/70">{SITE.footerInstitutionalLine}</p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-lunins-cream/60">{FOOTER_SITE.diferencaCanais}</p>
          </div>
          <div className="space-y-3 text-sm">
            <p className="font-semibold text-lunins-cream">Contato</p>
            <a
              href="https://www.instagram.com/luninsbr"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-lunins-cream/70 transition hover:text-lunins-gold"
            >
              <Instagram size={18} /> @luninsbr
            </a>
            <a
              href="mailto:comunicacao@lunins.org"
              className="flex items-center gap-2 text-lunins-cream/70 transition hover:text-lunins-gold"
            >
              <Mail size={18} /> comunicacao@lunins.org
            </a>
            <a
              href="tel:+5567992089769"
              className="flex items-center gap-2 text-lunins-cream/70 transition hover:text-lunins-gold"
            >
              <Phone size={18} /> (67) 99208-9769
            </a>
          </div>
          <div className="space-y-3 text-sm">
            <p className="font-semibold text-lunins-cream">Canais oficiais</p>
            <Link to="/loja" className="flex items-center gap-2 text-lunins-cream/70 transition hover:text-lunins-gold">
              Loja oficial
            </Link>
            <a
              href={LINKS_EXTERNOS.tutoriais}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-lunins-cream/70 transition hover:text-lunins-gold"
            >
              Tutoriais
            </a>
            <Link to="/#comprar" className="flex items-center gap-2 text-lunins-cream/70 transition hover:text-lunins-gold">
              Como a compra acontece
            </Link>
            <a
              href={LINKS_EXTERNOS.luninsOrg}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-lunins-cream/70 transition hover:text-lunins-gold"
            >
              <ExternalLink size={16} /> lunins.org
            </a>
            <a
              href={LINKS_EXTERNOS.luninsOrgSalas}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-lunins-cream/70 transition hover:text-lunins-gold"
            >
              <ExternalLink size={16} /> Salas (institucional)
            </a>
          </div>
          <div className="text-sm">
            <p className="font-semibold text-lunins-cream">Razão social</p>
            <p className="mt-2 leading-relaxed text-lunins-cream/70">
              <strong className="text-lunins-cream">L.D.Z Arquitetura Bem Estar LTDA</strong>
              <br />
              CNPJ 63.105.156/0001-57
            </p>
            <p className="no-print mt-4 text-xs text-lunins-cream/50">
              <strong className="text-lunins-cream/75">Entrega e frete</strong> — {FOOTER_SITE.entregaResumo}
            </p>
          </div>
        </div>
        <p className="mt-12 border-t border-white/10 pt-8 text-center text-xs text-lunins-cream/45">
          © {new Date().getFullYear()} Lunins. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
